import VUE from 'vue'
import VUEX from 'vuex'
import exam from './modules/examStore';

VUE.use(VUEX)

const state = {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    loginInfo: localStorage.getItem('loginInfo') ? localStorage.getItem('loginInfo') : {},  

    //本地
    //downloadUrl: 'http://192.168.10.222:20021/api/',
    //正式 20007
    downloadUrl: 'https://exam.buildone.com.cn/api/',
    //模拟 20021
    //downloadUrl: 'https://223.105.80.102:20021/api/',
    //downloadUrl: 'https://exammoni.buildone.com.cn:20021/api/',
    questionsDownloadUrl:'https://cloud.buildone.com.cn/zhangshangzhuanyuantimu-231229.zip',
    hasKityformula:false,        
}

const mutations = {
    saveToken(state, param){
        state.token = param.token;
        localStorage.setItem('token', param.token);
    },
    deleteToken(state){
        state.token = '';
        localStorage.setItem('token', '');
    },  
    saveLoginInfo(state, param){
        state.loginInfo = param.loginInfo;
        localStorage.setItem('loginInfo', param.loginInfo);
    },
    deleteLoginInfo(state){
        state.loginInfo = {};
        localStorage.setItem('loginInfo', {});
    },
    changeKityformula(state, param){
        state.hasKityformula = param.hasKityformula
        localStorage.setItem('hasKityformula', param.hasKityformula);
    }
}

export default new VUEX.Store({
    modules: {
        exam
    },
    namespaced: true,
    state,
    mutations, 
})

